import { useState } from 'react';
import { toast } from '../lib/motion';

/** Copies a number (SQ no., PO no.) to the clipboard; the icon turns into ✓ for a moment and "Copied" shows. */
export function CopyButton({ text, label }: { text: string; label: string }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setDone(true);
      toast(`${label} copied`);
      window.setTimeout(() => setDone(false), 1400);
    } catch { /* clipboard blocked: nothing to show */ }
  };
  return (
    <button type="button" className={`copy-btn${done ? ' done' : ''}`} aria-label={`Copy ${label}`} title={`Copy ${label}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); void copy(); }}>
      {done
        ? <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
        : <svg viewBox="0 0 16 16" aria-hidden="true"><rect x="5" y="5" width="8" height="9" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.5" /><path d="M3 11V3.5A1.5 1.5 0 0 1 4.5 2H10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>}
    </button>
  );
}
